import { useNavigate } from 'react-router-dom';

const OrderPending = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="container wrapper mt-5">
      <h1 className="text-center mb-4">Pago Pendiente</h1>
      <h5 className="text-center">
        Su pago está pendiente de confirmación.
      </h5>
      <h5 className="text-center">
        Por favor, espere unos instantes o contáctenos para mayor información.
      </h5>
      <div className="text-center mt-4">
        <button className="btn btn-primary" onClick={handleGoHome}>
          Volver a la página principal
        </button>
      </div>
    </div>
  );
};

export default OrderPending;
